import React from 'react';
import { connect } from 'react-redux';
import { CardTitle, InviteCodeDialog, OpenRedpackDialog } from '../../components';
import { ready, $http, copy, post } from '../../lib/kbApp/kbJsBridgePromise';
import { detector } from '../../lib/util/Detect.js';
import { getWelfareCenterParams, doPreProcess } from '../../rootStore';
import { getHost } from '../../const';
import { query } from '../../lib/util/common';
import { getSchemeHeader } from '../../lib/util/utils';
import { setDialogs, setBindCodeData } from '../../actions';
import { showTip } from '../../lib/util/domUtil.js';
import bindRelationshipError from '../../const/bindRelationshipError';
import './index.scss';

class InviteCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newUser: false,
      inviteCode: '',
      prenticesUser: [{}, {}, {}, {}, {}],
      prenticesUserInfos: [],
      selfUserInfo: {},
      masterUserInfo: {},
      newUserInfo: {},
      bindInvideCodeshow: true,
      profileIdMatch: false,
    };
    this.Log = this.props.Log;
  }

  componentDidMount() {
    ready().then(() => {
      this.getInviteCode(); // 获取邀请码
      this.getUserRelationList(); // 获取用户师徒关系
      this.matchProfileIdList();

      if (query('invite_code')) {  // 参数中带了邀请码，默认绑定
        this.bindRelationship();
      }
    });

    this.Log && this.Log.sendExposure({
      element_type: 'invite',
      element_name: 'module',
    });
  }

	bindRelationship = () => {
	  const param = Object.assign(getWelfareCenterParams(), {
	    inviteCode: query('invite_code') || '',
	  });

	  post(`${getHost()}/newtickets/api/kuaibao/bindRelationshipByCode`, param).then((res) => {
	      this.props.dialogs.pop();
	      const len = this.props.dialogs.length;

	      if (res.code === 0) {
	        this.props.dispatch(setBindCodeData(res.data));
	        this.props.dispatch(setDialogs(this.props.dialogs.concat([
						<OpenRedpackDialog key={len} num={res.data.prenticeAmount / 100} desc="领取成功，已存入现金余额中" from="inviteCode" history={this.props.history}></OpenRedpackDialog>,
	        ])));

	        this.Log && this.Log.sendExposure({
	          element_type: 'invite',
	          element_name: 'bind_popup_success',
	        });
	      } else {
	        const msg = bindRelationshipError[res.code] ? bindRelationshipError[res.code] : res.msg;
	        showTip(msg, 3000);

	        this.Log && this.Log.sendExposure({
	          element_type: 'invite',
	          element_name: 'bind_popup_fail',
	        });
	      }
	    });
	}

	// 复制邀请码
	copyInvideCode = () => {
	  copy(this.state.inviteCode);
	}

	// profileId
	matchProfileIdList = () => {
	  $http.post('/newtickets/api/matchProfileIdList', {
	    data: Object.assign(getWelfareCenterParams(), {
	      profileIDList: [72061, 5069],
	    }),
	  }).then((res) => {
	    if (res.code === 0) {
	      if (res.data && res.data.vMatchList && res.data.vMatchList.length > 0) {
	        console.log('matchProfileid', res.data.vMatchList);
	        const profileId = Number(res.data.vMatchList[0]);

	        if (profileId === 72061 || profileId === 74357 || profileId === 5069 || profileId === 5180) {
	          this.setState({
	            profileIdMatch: true,
	          });
	        }
	      }
	    }
	  });
	}

	// 获取邀请码
	getInviteCode = () => {
	  $http.get('/newtickets/api/kuaibao/getInviteCode', {
	    params: Object.assign(getWelfareCenterParams(), {}),
	  }).then((res) => {
	    if (res.code === 0) {
	      this.setState({
	        inviteCode: res.data.inviteCode || '',
	      });
	    }
	  });
	}

	// 获取用户师徒关系
	getUserRelationList = () => {
	  $http.get('/newtickets/api/kuaibao/getUserRelationList', {
	    params: Object.assign(getWelfareCenterParams(), {}),
	  }).then((res) => {
	    if (res.code === 0) {
	      const data = res.data || {};
	      this.setState({
	        prenticesUserInfos: data.prenticesUserInfos || '',
	        selfUserInfo: data.selfUserInfo || {},
	        masterUserInfo: data.masterUserInfo || {},
	        newUserInfo: data.newUserInfo || {},
	      });

	      // 老用户或者用户师傅绑定已过期则不展示
		  if (!this.props.isNewUser
			|| (data.masterUserInfo
				&& data.masterUserInfo.endTime
				&& new Date(data.masterUserInfo.endTime * 1000) < new Date())
			|| (data.newUserInfo && data.newUserInfo.actId)) {
	        this.setState({
	          bindInvideCodeshow: false,
	        });
	      }
	    }
	  });
	}

	// 收益记录
	toIncome = (tab) => {
	  this.props.history.push({ pathname: '/incomeRecord', state: {
	    tab,
	  } });
	}

	// 跳转到旧版邀请详情页
	toInviteFriend = () => {
	  const url = `${getHost()}/welfare/inviteFriend?refer=welfare_new`;
	  window.location.href = `${getSchemeHeader()}://webview?url=${encodeURIComponent(url)}&innerfrom=welfare_new`;
	}

	// 输入邀请码
	showInputCode = () => {
	  if (this.state.masterUserInfo.startTime || this.props.bindCodeData.prenticeAmount) { // 已绑定不可点
	    return;
	  }  // 未绑定
	  const len = this.props.dialogs.length;
	  this.props.dispatch(setDialogs(this.props.dialogs.concat([
				<InviteCodeDialog key={len} from="inviteCard" Log={this.Log}></InviteCodeDialog>,
	  ])));
	}

	render() {
	  const { inviteCode, prenticesUser, prenticesUserInfos, selfUserInfo, masterUserInfo } = this.state;
	  const { bindCodeData } = this.props;

	  return (
			<div className="inviteCard">
				<div className="coinWrap">
					<div className="titleWrap">
						<CardTitle title="邀请好友赚现金" subTitle="邀请1位好友，各得最高20元"></CardTitle>
					</div>
					{/* <div className="coin"></div> */}
				</div>
				<div className="signinBoard">
					<div className="friend">

						{prenticesUserInfos.length > 0
						  ? <React.Fragment>
								已邀请{prenticesUserInfos.length}人，累计收益<span className="totalNum">{selfUserInfo.totalAmountWelfare}</span>元
								<div className="inviteDetail" onClick={() => doPreProcess(this.toIncome)('cash')} log-click-eltype="invite" log-click-elname="inviteCash">
									查看余额
								</div>
							</React.Fragment>
						  : 							<React.Fragment>
								我的好友列表
								<div className="inviteDetail" onClick={() => doPreProcess(this.toInviteFriend)()} log-click-eltype="invite" log-click-elname="inviteDetail">
									查看详情
								</div>
							</React.Fragment>
						}
					</div>

					<div className="inviteList" onClick={() => doPreProcess(this.toInviteFriend)()}>
						{prenticesUser.map((prentices, index) => {
						  const userImage = prenticesUserInfos[index] && prenticesUserInfos[index].userImage ? prenticesUserInfos[index].userImage : '';

						  return (
								<div className="item" key={index}>
									<div className="avatar">
										{userImage
											&& <img src={userImage} alt=""/>
										}
									</div>
								</div>
						  );
						})}
					</div>

					<div className="inviteBtn"  onClick={() => doPreProcess(this.toInviteFriend)()} log-click-eltype="invite" log-click-elname="inviteBtn"><span className="icon"></span>微信邀请好友赚现金</div>
					<div className="more" onClick={() => doPreProcess(this.toInviteFriend)()} log-click-eltype="invite" log-click-elname="inviteMore">
						<span>更多邀请好友方式</span><span className="icon"></span>
					</div>
					{((this.state.profileIdMatch || detector.os.ios) && this.state.bindInvideCodeshow)
					  ? <div className="myCode">
							<div className="inviteCode">
								<span className="codeDetail">我的邀请码: {inviteCode}</span>
								<span className="copy" onClick={() => this.copyInvideCode()} log-click-eltype="invite" log-click-elname="inviteCopy">复制</span>
								|
								<span className={`friendCode ${(masterUserInfo.startTime || bindCodeData.prenticeAmount) ? 'binded' : ''}`} onClick={() => doPreProcess(this.showInputCode)()} log-click-eltype="invite" log-click-elname="inviteInput">
									{(masterUserInfo.startTime || bindCodeData.prenticeAmount) ? '已绑定' : '填写好友的邀请码'}
								</span>
							</div>
						</div>
					  :						<div className="myCode old">
							<span className="inviteCode">
								我的邀请码: {inviteCode}<span className="copy" onClick={() => this.copyInvideCode()} log-click-eltype="invite" log-click-elname="inviteCopy">复制</span>
							</span>
						</div>
					}

				</div>
			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, bindCodeData, isNewUser, preProcess } = state;
  return {
    dialogs, bindCodeData, isNewUser, preProcess,
  };
};

export default connect(mapStateToProps)(InviteCard);
